// The pin menu a channel row raises on right-click. DM rows never raise one:
// the caller decides that by the channel's type, and this component is not
// mounted for them.

import { useRef } from 'react';
import { useDismissibleLayer } from '../hooks/useDismiss';

interface Props {
  x: number;
  y: number;
  pinned: boolean;
  onPin: () => void;
  onUnpin: () => void;
  onClose: () => void;
}

export const PIN_LITERAL = '置顶';
export const UNPIN_LITERAL = '取消置顶';

export default function ChannelContextMenu({
  x,
  y,
  pinned,
  onPin,
  onUnpin,
  onClose,
}: Props) {
  const ref = useRef<HTMLMenuElement>(null);

  useDismissibleLayer({
    active: true,
    within: ref,
    onEscape: onClose,
    onOutsidePress: onClose,
    deferred: true,
  });

  return (
    <menu
      ref={ref}
      style={{ position: 'fixed', left: x, top: y, zIndex: 1000 }}
      role="menu"
      data-context="channel-pin"
      className="channel-context-menu"
    >
      {pinned ? (
        <button
          className="channel-context-menu-item"
          onClick={() => {
            onUnpin();
            onClose();
          }}
        >
          {UNPIN_LITERAL}
        </button>
      ) : (
        <button
          className="channel-context-menu-item"
          onClick={() => {
            onPin();
            onClose();
          }}
        >
          {PIN_LITERAL}
        </button>
      )}
    </menu>
  );
}
